import axios from 'axios';

const getStores = async () => await axios.get(`/api/${localStorage.getItem("merchantId")}/store`);

export {
    getStores
}